module.exports = __webpack_public_path__ + "site/img/207.37da8554.jpg";